import React from 'react';
import {
 Card, CardContent, CardHeader, CardTitle
} from 'shared/components/ui/card';
import {
 useNavigate
} from 'react-router-dom';
import {
 Database, Cable, GitBranch, Zap, Shield
} from 'lucide-react';
import {
 useDataBuilderV2
} from '../DataBuilderV2Context';

interface StatCardItem {
    title: string;
    value: number;
    icon: React.ElementType;
    href: string;
}

const DashboardStatCards: React.FC = () => {
    const {
 schemaCount, connectionCount
} = useDataBuilderV2();
    const navigate = useNavigate();

    const stats: StatCardItem[] = [
        {
 title: 'Schemas',
value: schemaCount,
icon: Database,
href: 'connections'
},
        {
 title: 'Connections',
value: connectionCount,
icon: Cable,
href: 'connections'
},
        {
 title: 'Workflows',
value: 0,
icon: GitBranch,
href: 'workflows'
},
        {
 title: 'Triggers',
value: 0,
icon: Zap,
href: 'triggers'
},
        {
 title: 'Security Rules',
value: 0,
icon: Shield,
href: 'security'
},
    ];

    return (
        <div className="grid gap-4 md:grid-cols-3 lg:grid-cols-5">
            {stats.map((stat) => (
                <Card
                    key={stat.title}
                    className="cursor-pointer transition-colors hover:bg-accent"
                    onClick={() => navigate(stat.href)}
                >
                    <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                        <CardTitle className="text-sm font-medium">{stat.title}</CardTitle>
                        <stat.icon className="h-4 w-4 text-muted-foreground" />
                    </CardHeader>
                    <CardContent>
                        <div className="text-2xl font-bold">{stat.value}</div>
                    </CardContent>
                </Card>
            ))}
        </div>
    );
};

export default DashboardStatCards;
